import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'

function parseParam(raw: string | null): string[] {
  if (!raw) return []
  return raw.split(',').filter(Boolean)
}

export function useNetworkKeywordFilter(): {
  keywordFilter: string[]
  setKeywordFilter: (next: string[]) => void
} {
  const [searchParams, setSearchParams] = useSearchParams()

  const keywordFilter = parseParam(searchParams.get('keyword'))

  const setKeywordFilter = useCallback(
    (next: string[]) => {
      setSearchParams(
        (prev) => {
          const updated = new URLSearchParams(prev)
          if (next.length === 0) {
            updated.delete('keyword')
          } else {
            updated.set('keyword', next.join(','))
          }
          return updated
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  return { keywordFilter, setKeywordFilter }
}
